import { Box, Typography, Divider, Stack, Link } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

// Data
import { categoriasForNavigationBar } from '../data/categorias-prisma';
import { Rutas } from '@/constants/rutas';
import { usePrismaContext } from '../context/PrismaContext';

const PrismaFooter = () => {
    const theme = useTheme();
    const currentYear = new Date().getFullYear();
    const { getCategoryName, getNavigationLabel } = usePrismaContext();

    const categorias = categoriasForNavigationBar();

    const LINKS = [
        { nameKey: 'contacto', href: Rutas.PRISMA_CONTACTO },
        { nameKey: 'politicaPrivacidad', href: Rutas.PRISMA_POLITICA_DE_PRIVACIDAD },
        { nameKey: 'terminosCondiciones', href: Rutas.PRISMA_TERMINOS_Y_CONDICIONES },
        { nameKey: 'analiticaFantasy', href: Rutas.INICIO },
        { nameKey: 'siguenos', href: 'https://twitter.com/AnaliticaFantasy' },
    ];

    // =========== sx helpers (estilos uniformes) ===========
    const bgSurface = theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100];

    const sectionTitleSx = {
        fontWeight: 800,
        letterSpacing: 0.2,
        color: theme.palette.primary.main,
        mb: 2,
    };

    const bodyMutedSx = {
        color: 'text.secondary',
        lineHeight: { xs: 1.6, md: 1.7 },
    };

    const linkBaseSx = {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 0.5,
        px: 0,
        color: 'text.secondary',
        textDecoration: 'none',
        transition: 'all .25s ease',
        '&:hover': { transform: 'scale(1.05)' },
    };

    return (
        <Box sx={{ bgcolor: bgSurface, borderTop: `1px solid ${theme.palette.divider}`, p: 2 }}>
            <Box className="container">
                {/* BLOQUE 2: Categorías + Enlaces */}
                <Box display={'flex'} justifyContent={'flex-start'} flexWrap="wrap" gap={4}>
                    {/* Categorías */}
                    <Box>
                        <Typography variant="h5" sx={sectionTitleSx}>
                            {getNavigationLabel('categorias')}
                        </Typography>
                        <Stack>
                            {categorias.map((categoria) => (
                                <Link
                                    key={categoria.id}
                                    href={`/prisma/categoria/${categoria.id}`}
                                    underline="none"
                                    sx={linkBaseSx}
                                >
                                    <Typography variant="body2">{getCategoryName(categoria.id)}</Typography>
                                </Link>
                            ))}
                        </Stack>
                    </Box>

                    <Box>
                        <Typography variant="h5" sx={sectionTitleSx}>
                            {getNavigationLabel('enlacesUtiles')}
                        </Typography>
                        <Stack>
                            {LINKS.map((l) => (
                                <Link key={l.nameKey} href={l.href} underline="none" sx={linkBaseSx}>
                                    <Typography variant="body2">{getNavigationLabel(l.nameKey)}</Typography>
                                </Link>
                            ))}
                        </Stack>
                    </Box>
                </Box>

                <Divider sx={{ my: 4 }} />

                {/* BLOQUE 4: Copyright */}
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="subtitle1" color="text.primary" fontWeight={800} gutterBottom>
                        © {currentYear} Prisma
                    </Typography>
                    <Typography variant="body2" sx={{ ...bodyMutedSx, mb: 1.5 }}>
                        {getNavigationLabel('copyright')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PrismaFooter;
